export default __webpack_public_path__ + "static/media/racelab-logo-white-side.6ef69a9f.svg";